<h2 mat-dialog-title>Cambiar cuenta de banco</h2>

<mat-dialog-content>
  <p class="dialog-description">
    Esta acción solo actualizará la cuenta asociada al egreso. No modificará
    saldos, conciliaciones ni órdenes relacionadas.
  </p>

  <div class="risk-warning" role="alert">
    <i-tabler name="alert-triangle"></i-tabler>
    <div>
      <strong>Cambio de riesgo</strong>
      <p>
        Verifique cuidadosamente la cuenta y la moneda. Una cuenta incorrecta
        puede hacer que el egreso aparezca en un flujo bancario que no le
        corresponde. El cambio solo está permitido mientras el egreso continúe
        EN PROCESO y sea de tipo Orden de Servicio.
      </p>
    </div>
  </div>

  <div class="current-account">
    <span class="current-account__label">Cuenta actual</span>
    <span>
      {{ data.cuentaActualNombre || "Sin cuenta asignada" }}
      <ng-container *ngIf="data.cuentaActualTipo">
        · {{ data.cuentaActualTipo }}
      </ng-container>
    </span>
  </div>

  <mat-form-field appearance="outline" class="account-field">
    <mat-label>Nueva cuenta de banco</mat-label>
    <mat-select [formControl]="cuentaControl">
      <mat-option
        *ngFor="let cuenta of cuentasDisponibles"
        [value]="cuenta.id"
      >
        {{ cuenta.nombre }} · {{ cuenta.tipo }}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="cuentaControl.hasError('required')">
      Seleccione una cuenta de banco.
    </mat-error>
  </mat-form-field>

  <p *ngIf="!cuentasDisponibles.length" class="empty-accounts">
    No existen otras cuentas bancarias disponibles en
    {{ data.cuentaActualTipo || "la misma moneda" }}.
  </p>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="cuentaControl.invalid || !cuentasDisponibles.length"
    (click)="confirm()"
  >
    Cambiar cuenta
  </button>
</mat-dialog-actions>
